import { useLayoutEffect } from "react";
import type { BlogPost } from "@shared/schema";
import { queryClient } from "./queryClient";

export function hydrateBlogInitialData() {
  const element = document.getElementById("blog-initial-data");
  if (!element?.textContent) return;

  try {
    const payload = JSON.parse(element.textContent) as {
      canonicalPath?: string;
      data?: { post?: BlogPost; posts?: BlogPost[] };
    };
    const path = window.location.pathname.replace(/\/+$/, "") || "/";
    if (payload.canonicalPath !== path || !payload.data) return;

    if (path === "/blog" && Array.isArray(payload.data.posts)) {
      queryClient.setQueryData(["/api/blog"], payload.data.posts);
    } else if (
      typeof payload.data.post?.slug === "string" &&
      path === `/blog/${payload.data.post.slug}`
    ) {
      queryClient.setQueryData(["/api/blog", payload.data.post.slug], payload.data.post);
    }
  } catch {
    // Invalid or unavailable bootstrap data falls back to the normal API query.
  } finally {
    element.remove();
  }
}

export function useRemoveBlogPrerender(ready: boolean) {
  useLayoutEffect(() => {
    if (ready) document.getElementById("ssr-route-prerender")?.remove();
  }, [ready]);
}
